<template>
  <div class="page" id="mixed-notes">
    <div class="decorative-texture top">
      <img :src="require(`@/assets/img/texture.png`)" />
    </div>
    <div class="decorative-texture position-bottom movil-only">
      <img :src="require(`@/assets/img/texture.png`)" />
    </div>
    <vue-snotify></vue-snotify>
    
    <mnavbar></mnavbar>

    <div class="toolBar">
      <div class="row">
        <div class="col-lg-5 col-xl-5 col-md-5 col-sm-3 col-xs-12">
          <h2 class="toolBarTitle" >Notas</h2>
        </div>
        <div class="col-lg-2 col-xl-2 col-md-2 col-sm-1 col-xs-12 text-center">
            <label class="sub">{{getMedio()}}</label><br>
            <label class="sub"> {{  getFechas({dias:copy_query.dias}) }} </label><br>
            <label class="sub"  v-if="copy_query.hora">{{copy_query.hora.ini}} - {{copy_query.hora.fin}}</label>
        </div>

        <div class="toolActions col-xs-12 col-sm-8 col-lg-5 col-xl-5 col-md-5">
          <div class="mi-select">
            <v-select 
              :value="options[view-1]" 
              :reduce="option => option.value" 
              :searchable="false"
              :filterable="false"
              :clearable="false" 
              class="style-chooser" 
              :options="options" 
              @input="setSelected">
            </v-select>
            </div>

          <div class="separator"></div>

        </div>
        <!--BOTONES-->
      </div>
    </div>

    <tool-menu :menuOn="showOn" @menuVisible="toolVisible" :fi="fi" @selectMedia="setFi" :keywords="keywords" :keywordSelected="keywordSelected" @setKeyword="setKeyword"></tool-menu>
    
    <div v-if="conf" class="back-button2 button tooltip tooltip-left noPadding" @click="toolVisible" data-tooltip="Configuración de Busqueda">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cog" class="svg-inline--fa  fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"></path></svg>
    </div>
    <section class="noPadding">
      <panel-notas
        v-if="view==1"
        from="public"
        :items="items"
        :query="cquery"
        :LastEvaluatedKey="LastEvaluatedKey"
        @goToNote="goToNote"
        @loadMore="loadMore"
      ></panel-notas>
      <panel-text
        v-if="view==2"
        from = "public"
        :items="items"
        :LastEvaluatedKey="LastEvaluatedKey"
        :query="copy_query"
        @goToNote="goToNote"
        @loadMore="loadMore"
      >
      </panel-text>
      <timeline 
        v-if="view==3"
        from = "public"
        :items="items" 
        :LastEvaluatedKey="LastEvaluatedKey" 
        @loadMore="loadMore"
        @goToNoteTimeline="goToNote"
      ></timeline>

      <!--<origen :isActive="origenDat" :query="copy_query" @cerrar="origen"></origen>-->
    </section>
  </div>
</template>



<script>

import mnavbar from "@/components/public/mnavbar";
import toolMenu from "@/components/toolMenu";

import panelNotas from "@/components/panelNotas";
import panelText from "@/components/panelText";
import timeline from "@/components/timeline";


import emptyPage from "@/components/emptyPage";
import origen from "@/components/origen";

import { library } from "@fortawesome/fontawesome-svg-core";
import {  faCloudDownloadAlt, faInfoCircle } from "@fortawesome/free-solid-svg-icons";


library.add(faInfoCircle);
library.add(faCloudDownloadAlt);

import moment from "moment-timezone"

export default {
  name: "notas",
  components: { mnavbar, panelNotas, emptyPage,origen,panelText,toolMenu,timeline },
  props: ["from", "item", "backData", "dashboardKey", "query", "keywordsG","params","ipid" ,"conf"],
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      query_result: {},
      view:this.$store.state.mode,
      showOn:false,
      items: [],
      total: 0,
      LastEvaluatedKey: 0,
      limit: 12,
      keywordSelected: 0,
      keywords: [],
      empty: false,
      fi: [],
      gaugeQuery: {},
      query_fi: {},
      copy_query: [],
      cquery: {},
      origenDat:false,
      backData2:null,
      from2:null,
      options:[{label:'Modo Gráfico',value:1},{label:'Modo Texto',value:2},{label:'Escaleta',value:3}],
      view:3

    };
  },
  watch:{
    view(){
      this.$store.commit('saveMode',this.view)
    }
  },
  beforeMount() {
    //de donde viene?
    console.log("####################",this.conf)

    var backData2 = this.$store.state.backData2;
    
    this.from2 = backData2.length>0?backData2[backData2.length-1].from:'/main';
    this.backData2 = backData2.length>0?backData2[backData2.length-1]:null;
    

    var mi_query = {};
   
    if (this.query) {//console.log('query viene de props');
      this.$store.commit('saveQuery',this.query);
      mi_query = this.query;
    } else {//hay en el store?
      mi_query = Object.assign({}, this.$store.state.query);
    }
   
    this.copy_query = Object.assign({}, mi_query);
    //this.keywords.push(mi_query.keywords);
    //this.keywords = mi_query.keywords;
    let tem  = mi_query.keywords;
    this.keywords = mi_query.keywords.split(',');
    mi_query.keywords = this.keywords

    this.selectedFi = mi_query.fi;
    for (var red in mi_query.fi) {
      var obj = { fi: red, selected: true };
      this.fi.push(obj);
    }
    this.query_fi = mi_query.fi;
    var hoy = moment
      .tz( "America/Mexico_City")
      .format("DD-MM-YYYY");
    this.fName = "Búsqueda_"+ hoy;

    this.loadItems();
  },
  methods: {
    setSelected(value){
      this.view = value;
    },
     loadItems() {
      var self = this;
      var mi_query = Object.assign({}, this.copy_query);
      mi_query["limit"] = this.limit;
      mi_query["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var miKeyword = [];
      if(mi_query.keywords.length>0){
        mi_query.keywords = [];
        
        mi_query.keywords.push(this.keywords[this.keywordSelected]);
      // mi_query.keywords.push(this.keywords)
       //this.keywords = mi_query.keywords



        var fi_ = {};
        for (var i in this.fi) {
          var fi = this.fi[i];
          if (fi.selected) {
            fi_[fi.fi] = this.query_fi[fi.fi];
          }
        }

        mi_query.fi = fi_;
      }

      if(this.ipid)
        mi_query.ipid = this.ipid;
      
      axios
        .post(this.url + "queryElasticSearchV5", mi_query)
        .then(response => {
          
          if (response.data.success) {
            self.isLoading = false;
            //self.query_result = JSON.parse(response.data.data);
            self.query_result = response.data.data;
          
            //for (var i in self.query_result) {
              var data = self.query_result;
              var arr_result = data.result;
              self.total = data.total;
              self.empty = self.total > 0 ? false : true;
              self.LastEvaluatedKey =
                self.limit + self.LastEvaluatedKey > self.total
                  ? -1
                  : self.limit + self.LastEvaluatedKey;
              for (var j in arr_result) {
                self.items = [].concat(self.items, arr_result[j]);
              }
              self.isEmpty = self.items.length>0? false:true;
            //}
            //console.log(self.LastEvaluatedKey)
          }
        })
        .catch(function(error) {
          self.isLoading = false;
          self.error(error);
        });
    },
    loadMore() {
      this.isLoading = true;
      if (this.LastEvaluatedKey == -1) {
        this.$snotify.info("Ya no ha más notas", "Info");
      } else {
        this.loadItems();
      }
    },
    menuVisible(menu) {
      this.menuOn = menu;
    },
    toolVisible() {
      this.showOn = !this.showOn;
    },
    origen(){
      this.origenDat = !this.origenDat;
    },
    hideModal() {
      this.showModal = false;
    },
    setKeyword(ndx) {
    
      this.keywordSelected = ndx;
      this.reload();
    },
    setFi(ndx) {
      console.log(ndx);
      console.log(this.fi[ndx]);
      this.fi[ndx].selected = !this.fi[ndx].selected;
      var cont = 0;
      var totalFi = this.fi.length;
      for (var i in this.fi) {
        var fi = this.fi[i];
        if (!fi.selected) cont++;
      }
      if (cont == totalFi) {
        this.fi[ndx].selected = !this.fi[ndx].selected;
        this.$snotify.error(
          "No puede dejar sin fuente de información",
          "Error"
        );
      } else {
        //console.log(this.fi)
        this.reload();
      }
    },
    reload() {
      this.isLoading = true;
      this.clear();
      this.loadItems();
    },
    clear() {
      this.items = [];
      this.LastEvaluatedKey = 0;
      this.query_result = {};
    },
    goBack() {
      
      var backData2 = this.$store.state.backData2;
      
      var data = backData2.pop();

      if(data == undefined || data == null) {
        this.$router.back();
      }
      else{
        var from = data.from;
        var params = data.fromParams;
        console.log(name);
        console.log(params)
        this.$router.push({
          name:from,
          params:params
        });
      }
    },
    goToNote(obj) {

      var note_params = {
        table:this.getTable(obj.entrada),
        key:obj.key,
        ipid: this.$store.state.publicUser.ipid,
        subparams:this.backData2? this.backData2.fromParams.data:{}
      };
      
      var encrypted = this.$CryptoJS.AES.encrypt(JSON.stringify(note_params),'secret 1576508387911');


      var p = { from :'publicNotas', fromParams:{ params:this.params } };
      this.$store.commit('saveBack2',p);

      this.$router.push({name:'public',params:{type:'nota', data:encodeURIComponent(encrypted)}});

    },
    getTable(fi){
      var table = "";
      switch(fi){
        case 'T': 
        case 'R': table = 't_notas' 
        break;
        case 'FB':  table = 't_facebook'; break;
        case 'Y':  table = 't_youtube'; break;
        case 'I':  table = 't_instagram'; break;
        case 'TW':  table = 't_twitter'; break;
        case 'PD':  table = 't_rss'; break;
      }
      return table;
    },
     getMedio(){
      var arr = [];
      if (this.copy_query.fi.FB) {
        arr.push("Facebook")
      }
      if (this.copy_query.fi.I) {
        arr.push("Instagram")
      }
      if (this.copy_query.fi.TW) {
        arr.push("Twitter")
      }
      if (this.copy_query.fi.PD) {
        arr.push("Portales digitales")
      }
      if (this.copy_query.fi.R) {
        arr.push("Radio")
      }
      if (this.copy_query.fi.T) {
        arr.push("Televisión")
      }
      if (this.copy_query.fi.Y) {
        arr.push("Youtube")
      }
      
      return arr.toString();

    },
    getFechas(obj){
      var dias = obj.dias; //dias atrás
      var fecha = moment();
      var fechaFin = moment.tz(fecha,'America/Mexico_City').format('DD/MM/YYYY');
      var fecha2 = fecha.subtract(dias-1, 'days'); 
      var fechaInicio = moment.tz(fecha2,'America/Mexico_City').format('DD/MM/YYYY'); 
      var f = fechaInicio + ' - ' + fechaFin;
      return f;
    },
    error(msg) {
      this.$snotify.error(msg, "Error");
    },
    success(msg) {
      this.$snotify.success(msg, "Success");
    }
  }
};
</script>

